import { Paper, Stack } from "@mantine/core"
import type { ReactNode } from "react"
import type { TQuestionType } from "@/types"
import { QuestionTitle } from "../QuestionTitle"
import { MultiAnswerBoolean } from "./MultiAnswerBoolean"
import { MultiAnswerComments } from "./MultiAnswerComments"
import { MultiAnswerDate } from "./MultiAnswerDate"
import { MultiAnswerLikert } from "./MultiAnswerLikert"
import { MultiAnswerMultiple } from "./MultiAnswerMultiple"
import { MultiAnswerNumber } from "./MultiAnswerNumber"
import { MultiAnswerPersonal } from "./MultiAnswerPersonal"
import { MultiAnswerScale } from "./MultiAnswerScale"
import { MultiAnswerSingle } from "./MultiAnswerSingle"
import { MultiAnswerString } from "./MultiAnswerString"
import { MultiAnswerTags } from "./MultiAnswerTags"
import type { IMultiAnswerProps } from "./types"

const renders: Record<TQuestionType, (props: IMultiAnswerProps) => ReactNode> = {
  string: MultiAnswerString,
  scale: MultiAnswerScale,
  boolean: MultiAnswerBoolean,
  number: MultiAnswerNumber,
  date: MultiAnswerDate,
  select: MultiAnswerSingle,
  multiple: MultiAnswerMultiple,
  likert: MultiAnswerLikert,
  tags: MultiAnswerTags,
  personal: MultiAnswerPersonal,
}

export function MultiAnswer(props: IMultiAnswerProps) {
  const Render = renders[props.question.type]
  if (!Render) {
    console.warn(`No render found for question type: ${props.question.type}`)
    return null
  }
  return (
    <Paper withBorder>
      <Stack p="sm">
        <QuestionTitle question={props.question} />
        <Render {...props} />
        <MultiAnswerComments {...props} />
      </Stack>
    </Paper>
  )
}
